module.exports = __webpack_public_path__ + "eivor.png";